import { createDiv } from '../../libs/HTML/HTMLElementCreator';

const alerts: HTMLDivElement[] = [];
const INITIAL_TOP = 20; // px from top of the screen

export function displayDebugAlert(alertText: string): void {
  const div = createDiv({
    parentElement: document.body,
    style: {
      position: 'fixed',
      width: '80%',
      padding: '1em',
      left: '10%',
      borderRadius: '1em',
      fontFamily: 'monospace',
      fontWeight: 'bold',
      top: `${INITIAL_TOP}px`,
      color: 'red',
      backgroundColor: 'yellow',
      transition: 'top 0.3s ease-out',
    },
  });

  div.innerText = alertText;

  // Add to our alerts array
  alerts.push(div);

  // Reposition all alerts
  repositionAlerts();

  setTimeout(() => {
    const index = alerts.indexOf(div);
    if (index > -1) {
      alerts.splice(index, 1);
      repositionAlerts();
    }
    div.remove();
  }, 3000);
}

function repositionAlerts(): void {
  let currentTop = INITIAL_TOP;

  alerts.forEach((alert, index) => {
    if (index === 0) {
      alert.style.top = `${currentTop}px`;
    } else {
      const previousAlert = alerts[index - 1];
      const previousRect = previousAlert.getBoundingClientRect();
      currentTop = previousRect.bottom + 10; // 10px gap between alerts
      alert.style.top = `${currentTop}px`;
    }
  });
}
